import { BATCH_5_HOMEPAGE_FIRST_SECTION_COPY_TEST_102124 } from "@faire/web-api--source/indigofair/settings/BATCH_5_HOMEPAGE_FIRST_SECTION_COPY_TEST_102124";
import { IFourVariantXP } from "@faire/web-api--source/indigofair/settings/IFourVariantXP";

import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";

export const useSettingHomePageFirstSectionCopyTestB5 = (): IFourVariantXP =>
  useSetting(
    BATCH_5_HOMEPAGE_FIRST_SECTION_COPY_TEST_102124,
    IFourVariantXP.Bucket.CONTROL
  );
